import React,{Component} from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import Menu from "@material-ui/core/Menu";
import { translate } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import PersonIcon from "@material-ui/icons/Person";
import LogoutIcon from "@material-ui/icons/PowerSettingsNew";
import Typography from "@material-ui/core/Typography";

import { gbConstants } from "../_constants";
import { images } from "../_assets";
import { notiService } from "../_services";
moment.locale('vi');
const styles = {
    message:{
		cursor:"pointer",
        paddingTop: 5,
        paddingLeft: "5px !important",
        "&:hover": {
            backgroundColor: "lightblue"
        },
        "&:active": {
            backgroundColor: "white"
        },
        "&:focus": {
            backgroundColor: "white"
        }
	},
    title:{
        paddingTop: 5,
        paddingLeft: 5,
    },
    iconNoti:{
        backgroundColor: "red",
        width: 20,
        height: 18,
        borderRadius: 10,
        paddingTop: 2,
        textAlign: "center",
        color: "white",
        marginTop: -9,
        marginLeft: 19,
        position: "absolute",
    },
}

class Notification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ids:[],
            newNoti:0,
            data:[],
            anchorNoti:null,
            left: false,
            iconFlag:false,
            openNoti:false,
        };
    }
	

    componentWillReceiveProps(nextProps) {
        if(nextProps.data.newNoti!==0 ||(this.state.data.length===0 && nextProps.data.noti.length!==0)){
            let newNoti=this.state.newNoti+nextProps.data.newNoti
            if(newNoti > 10 ){
                newNoti = 10
            }
            this.setState({
                ids:nextProps.data.ids,
                data:nextProps.data.noti,
                newNoti:newNoti,
                iconFlag:true,
            })
        }
    }
    toggleDrawer = (side, open) => () => {
        this.setState({
            [side]: open
        });
    };

    handleNoti = event => {
        this.setState({ anchorNoti: event.currentTarget ,iconFlag:false,openNoti:true,newNoti:0});
    };
    handleCloseNoti = (e,data) => {
        if (data.length > 0 ){
            //notiService.readNoti(data)
        }
        this.setState({ anchorNoti: null,openNoti:false });
    };
    render() {
		const { t,classes } = this.props;
        let data=this.state.data
        let newNoti=this.state.newNoti
		const { anchorNoti } = this.state;
		const openNoti = Boolean(anchorNoti);
        const self = this;
        function renderNotiMenu() {
            return (
                <Menu
                    id="Notification"
                    anchorEl={anchorNoti}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    open={openNoti}
                    onClose={ e => self.handleCloseNoti(e,data)}
                >
                    <div style={{borderRadius:5,paddingTop:10,paddingBottom:10,marginTop:-8,backgroundColor:"#269a89"}}>
                        <ListItemText
                            className={classes.title}
                            primary={
                                <Typography
                                    variant="title"
                                    style={{
                                        color:"white",
                                        textAlign:"center",
                                        fontSize: 18
                                    }}
                                >
                                    {t("Notification")}
                                </Typography>
                            }
                        />
                    </div>
                    <div style={{marginBottom:-8,maxHeight:200,overflow:"auto"}}>
                    {data.length > 0?
                    data.map((noti,index) => (
                        <div key={index}>
                            <Divider/>
                            <ListItemText
                                className={classes.message}
                                primary={
                                    <Typography
                                        variant="title"
                                        style={{
                                            fontSize: 14
                                        }}
                                    >
                                        {(noti.value != "NULL"? t(noti.action) +" : "+ noti.value +"đ": t("ShortCampaign") +" - "+ noti.campaign +" : " + t(noti.action))}
                                    </Typography>
                                }
                                secondary={
                                    <Typography
                                        variant="subheading"
                                        style={{
                                            fontSize: 10,
                                            marginTop: 5
                                        }}
                                    >
                                        {noti.createdAt? moment().to(moment(noti.createdAt)):" "}
                                    </Typography>
                                }

                            />
                            <Divider/>
                            <Divider/>
                        </div>
                        )):
                          <ListItemText
                                className={classes.message}
                                secondary={
                                    <Typography
                                        variant="subheading"
                                        style={{
                                            fontSize: 12,
                                            marginTop: 5
                                        }}
                                    >
                                        {t("NoNotification")}
                                    </Typography>
                                }

                            />  
                        }
                    </div>
                </Menu>
            );
        }
        let image = (
        	<svg width="35" height="40" viewBox="0 0 1024 1024" 
                style={{
                    fill:"#269a89",
                    cursor:"pointer"
                }} 
                onClick={this.handleNoti}>
            <path d={images.noti}></path>
            </svg>
        )
        let iconNoti = (
            <div className={classes.iconNoti} >
                {newNoti > 0 ? newNoti : null}
            </div>
            )
		return (
		<div>
            {this.state.iconFlag && !this.state.openNoti && newNoti > 0 ?iconNoti:""}
			{image}
			{renderNotiMenu()}
		</div>
		);
	}
}

function mapStateToProps(state) {
    const { noti } = state;
    if (noti.noti){
        let data=noti.noti
        return {
            data
        }
    }else {
        return{
            data:{
                ids:[],
                noti:[],
            }
        }
    }
}

export default connect(mapStateToProps)(
    withStyles(styles)(translate("translations")(Notification))
);


// WEBPACK FOOTER //
// ./src/AppMenu/Notification.js